import React from 'react'
import { Alert, Button, Modal, Spinner } from 'react-bootstrap'
import { FaExclamationTriangle, FaTrash } from 'react-icons/fa'

type ConfirmRemoveModalProps = {
    show: boolean
    onHide: () => void
    onConfirm: () => void | Promise<void>
    feedName: string
    isRemoving?: boolean
    error?: string
}

const ConfirmRemoveModal: React.FC<ConfirmRemoveModalProps> = ({
    show,
    onHide,
    onConfirm,
    feedName,
    isRemoving = false,
    error = '',
}) => {
    return (
        <Modal
            show={show}
            onHide={() => !isRemoving && onHide()}
            centered
            backdrop={isRemoving ? 'static' : true}
            keyboard={!isRemoving}
        >
            <Modal.Header closeButton={!isRemoving}>
                <Modal.Title>Remove feed?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger" role="alert">{error}</Alert>}
                <div className="feed-danger-prompt">
                    <span className="feed-danger-icon"><FaExclamationTriangle aria-hidden="true" /></span>
                    <div>
                        <p className="mb-2">
                            <strong>{feedName || 'This feed'}</strong> and its generated download links will be removed.
                        </p>
                        <p className="text-muted small mb-0">This action cannot be undone.</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide} disabled={isRemoving}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={isRemoving}>
                    {isRemoving ? (
                        <><Spinner animation="border" size="sm" className="me-2" />Removing…</>
                    ) : (
                        <><FaTrash aria-hidden="true" className="me-2" />Remove feed</>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmRemoveModal
